<div class="h-100 d-flex align-items-center justify-content-center">{{'block_nay_khong_co_quan_tri_du_lieu' | translate}}!</div>
